"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoryKeyStore = void 0;
var getKeyMetadata_1 = require("../Helpers/getKeyMetadata");
var MemoryKeyStore = /** @class */ (function () {
    function MemoryKeyStore() {
        this.name = "MemoryKeyStore";
        this.keyStore = {};
    }
    MemoryKeyStore.prototype.configure = function () {
        return Promise.resolve();
    };
    MemoryKeyStore.prototype.storeKeys = function (keys) {
        var _this = this;
        // We can't store keys if they're already there
        var invalidKeys = keys.filter(function (encryptedKey) { return !!_this.keyStore[encryptedKey.id]; });
        if (invalidKeys.length) {
            return Promise.reject("Some keys were already stored in the keystore: ".concat(invalidKeys
                .map(function (k) { return k.id; })
                .join(", ")));
        }
        var keysMetadata = keys.map(function (encryptedKey) {
            _this.keyStore[encryptedKey.id] = __assign({}, encryptedKey);
            return (0, getKeyMetadata_1.getKeyMetadata)(_this.keyStore[encryptedKey.id]);
        });
        return Promise.resolve(keysMetadata);
    };
    MemoryKeyStore.prototype.updateKeys = function (keys) {
        var _this = this;
        // we can't update keys if they're already stored
        var invalidKeys = keys.filter(function (encryptedKey) { return !_this.keyStore[encryptedKey.id]; });
        if (invalidKeys.length) {
            return Promise.reject("Some keys couldn't be found in the keystore: ".concat(invalidKeys
                .map(function (k) { return k.id; })
                .join(", ")));
        }
        var keysMetadata = keys.map(function (encryptedKey) {
            var id = encryptedKey.id;
            _this.keyStore[id] = __assign({}, encryptedKey);
            return (0, getKeyMetadata_1.getKeyMetadata)(_this.keyStore[id]);
        });
        return Promise.resolve(keysMetadata);
    };
    MemoryKeyStore.prototype.loadKey = function (id) {
        return Promise.resolve(this.keyStore[id]);
    };
    MemoryKeyStore.prototype.removeKey = function (id) {
        if (!this.keyStore[id]) {
            return Promise.reject(id);
        }
        var metadata = (0, getKeyMetadata_1.getKeyMetadata)(this.keyStore[id]);
        delete this.keyStore[id];
        return Promise.resolve(metadata);
    };
    MemoryKeyStore.prototype.loadAllKeys = function () {
        return Promise.resolve(Object.values(this.keyStore).map(function (item) { return item; }));
    };
    return MemoryKeyStore;
}());
exports.MemoryKeyStore = MemoryKeyStore;
